import { styled } from 'styled-components'

import { partitionArray } from 'js/lib/helpers'

const Wrapper = styled.div`
    table {
        word-break: normal;

        th,
        td {
            padding-top: 2px;
            vertical-align: baseline;
        }

        th {
            font-weight: ${(p) => p.theme.font.weight.normal};
            color: ${(p) => p.theme.color.text.grey};
            padding-right: 6px;
        }
    }
`

type FieldType = {
    name: string
    value: string
    guid: string
}

interface Props {
    fields: FieldType[]
    className?: string
}

const Field = ({ field }: { field: FieldType }) => (
    <tr>
        <th scope="row">{field.name}</th>
        <td>{field.value}</td>
    </tr>
)

export const Fields = ({ fields = [], className }: Props) => {
    const [siteFields, groupFields] = partitionArray(
        fields,
        (field) => field?.isOnVcard,
    )

    return (
        <Wrapper data-testid="fields" className={className}>
            <table>
                <tbody>
                    {siteFields.map((field) => (
                        <Field key={field.guid} field={field} />
                    ))}
                    {groupFields.map((field) => (
                        <Field key={field.guid} field={field} />
                    ))}
                </tbody>
            </table>
        </Wrapper>
    )
}

export default Fields
